/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferSystemConfigurationResponse } from '../../models/offer-system-configuration-response';

export interface GetOfferSystemConfiguration$Params {
  offerId: number;
  systemVariantId: number;
}

export function getOfferSystemConfiguration(http: HttpClient, rootUrl: string, params: GetOfferSystemConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferSystemConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferSystemConfiguration.PATH, 'get');
  if (params) {
    rb.path('offerId', params.offerId, {});
    rb.path('systemVariantId', params.systemVariantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferSystemConfigurationResponse>;
    })
  );
}

getOfferSystemConfiguration.PATH = '/offers/{offerId}/systems/{systemVariantId}';
